import React,{useState, useEffect} from "react";
import "./Tesimonial.css"
import {people} from "./Data";

const randomNumber = () => {
return Math.floor(Math.random() * people.length);
}
const Testimonial = () => {
 // const dato = people[0];
 const [index, setIndex] = useState(0);
 const [person, setPerson] = useState(people);
 const [bobo, setBobo] = useState(people[randomNumber()]);
 // console.log(bobo);

 useEffect(()=> {
 setBobo(people[randomNumber()]);
 // console.log(bobo);
 },[])
 
 
 // console.log(randomNumber());
 
 if(index > people.length || index === people.length) {
  setIndex(0);
 }
 // useEffect(() => {
 //  setInterval(() => {
 //   setIndex(index + 1);
 //   setPerson(people[index]);
 //  }, 5000)
 //  // return () => clearInterval(5000)
 // }, [index])

 return (
  <>
  <div className="container-fluid mt-5 testimony">
  <div className="testimonial-header mt-5">
  
  <p className="text-primary text-center">
   Testimony
  </p>
  <h2 className="text-center">
  Client Testimonials
  </h2>
  </div>
  <div className="row">
  
    {people.map((item) => {
     const { id, image, name, quote, title } = item;
     return (
      <div className="col-md-6" key={id}>
      
      
      <div className="testimonial-story py-4">
       <p className="text-center ">
     {quote}
  </p>
       <div className="underscore"></div>
      </div>
      <div className="testimonial-picture ">
       <div className="colo">
        <img src={image} className="img-circle" />
       </div>
       <div className="coloy">
        <h6 className="text-info text-center">{name}</h6>
        <p className="text-dark text-center">{title}</p>
       </div>
      </div>
      </div>
     )

    })}
  </div>

 
  </div>
   

  </>
 )
}

export default Testimonial